import { type Components, type Theme } from '@mui/material';
import { ChevronDownIcon } from 'icons';

export const MuiSelect: Components<Theme>['MuiSelect'] = {
  defaultProps: {
    IconComponent: ChevronDownIcon,
  },
  styleOverrides: {
    root: ({ theme, ownerState: { displayEmpty, value } }) => ({
      maxHeight: 48,
      padding: 0,
      paddingLeft: theme.spacing(2),
      gap: theme.spacing(1),
      boxSizing: 'border-box',
      '& fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[300],
      },
      '& .MuiSelect-icon': {
        color: theme.palette.grey[600],
        fontSize: 20,
        marginRight: theme.spacing(0.5),
        '@media print': {
          display: 'none',
        },
      },
      '&.MuiInputBase-sizeSmall': {
        height: 32,
        minHeight: 32,
        '& .MuiSelect-icon': {
          width: 20,
          height: 20,
          top: 'unset',
        },
      },
      '& .MuiSelect-select': {
        paddingTop: '14px',
        paddingBottom: '14px',
        paddingLeft: 0,
        '&[aria-expanded="true"]': {
          color: theme.palette.grey[400],
        },

        '& p': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },

        ...(displayEmpty &&
          !value && {
            color: theme.palette.grey[400],
          }),
      },
    }),
  },
};
